<!--NEw CODE-->


<div class="panel panel--components">
  <div class="panel__header">

    <section class="example-section">
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="ucInspection"
        (change)="ShowUCInspection($event)">{{'UC Inspection' | translate | async}}</mat-checkbox>
      
        <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="maintenaceInspection"
        (change)="ShowActionInspection($event)" [disableRipple]="true">{{'Maintenance Inspection' | translate |
        async}}</mat-checkbox>
      
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="eolInspection"
        (change)="ShowEOLInspection($event)">{{'End of Life Inspection' | translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" *ngIf="ThermEnabled"
        [(ngModel)]="thermographyInspection" (change)="ShowThermogarphyInspection($event)">{{'Thermography Inspection' |
        translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="LastInspectionWorn"
                    (change)="ShowCurrentStatus($event)">
        {{'Last % Worn Forecasted' | translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="ShowTodayWorn"
                    (change)="ShowTodayWornPercentage($event)">{{'% Worn Today' | translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="distance">{{'Distance' | translate |
        async
        }}
      </mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="distanceDifference">{{'Distance Difference' | translate | async}}</mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="jobsite">{{'Jobsite' | translate |
        async}}</mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="inspector">{{'Inspector' | translate |
        async}}</mat-checkbox>
      <mat-checkbox class="example-margin example-section-padding" [(ngModel)]="worn">{{'%Worn (heading)' | translate |
        async}}</mat-checkbox>

    </section>
    <!-- <mat-radio-group layout="row" [(ngModel)]="inspectionType" name="rdTotal_Details"  >
      <mat-radio-button value=0 class="primary" style="margin-left: 16px;"(change)="ChangeInspectionType($event)">{{'UC Inspections' | translate | async}}</mat-radio-button>
      <mat-radio-button value=1 style="margin-left: 16px;" (change)="ChangeInspectionType($event)"> {{'Thermography Inspections' | translate | async}} </mat-radio-button>
      <mat-radio-button value=2 style="margin-left: 16px;"(change)="ChangeInspectionType($event)"> {{'Both Inspections' | translate | async}} </mat-radio-button>
    </mat-radio-group> -->
    <button mat-raised-button color="warn" (click)="LoadMore()"><span
        class="material-icons button__icon">add</span><span class="button__text">{{'Load More' | translate | async}}</span></button>
  </div>
  <!-- <div class="panel__header" *ngIf="!ThermEnabled" style="display: flex; flex-direction: row-reverse;">
    <button mat-raised-button color="warn" (click)="LoadMore()"><span class="material-icons button__icon">add</span><span class="button__text">Load More</span></button>
  </div> -->

  <!--GEneral Inspection-->

  <div *ngIf="thermographyInspection==false">
    <div class="panel__content no-padding">
      <div class="center" *ngIf="LeftSystem==null && RightSystem==null">
        <mat-spinner></mat-spinner>
      </div>

      <div style="display: flex;flex-direction: row;" *ngIf="LeftSystem!=null">
        <div style="width:50%">
          <table class="table table--striped table--full-width">
            <tbody>
              <tr>
                <td></td>
                <td class="tdClass">{{'Notes' | translate | async}}</td>
                <td ></td>

              </tr>
              <tr>
                <td></td>
                <td class="tdClass">{{'Inspection Type' | translate | async}}</td>
                <td class="tdClass" *ngIf="ShowTodayWorn">{{'% Worn Today' | translate | async}}</td>
                <td class="tdClass">{{'Last Insp. % Worn' | translate | async}}</td>

              </tr>
              <tr>
                <td class="tdClass"> {{eqName}}</td>
                <td class="tdClass">{{'DATE' | translate | async}}</td>
                <td class="tdClass" *ngIf="ShowTodayWorn">{{ToadysDate | date:'dd-MMM-yyyy'}}</td>
                <td ></td>

              </tr>
              <tr>
                <td></td>
                <td class="tdClass">SMU</td>
                <td *ngIf="ShowTodayWorn">{{ForeacastCmu}}</td>
                <td > </td>

              </tr>
              <tr>
                <td></td>
                <td class="tdClass">{{'AVG Daily Usage' | translate | async}}</td>
                <td *ngIf="ShowTodayWorn"></td>
                <td > </td>

              </tr>
              <tr *ngIf="distance">
                <td></td>
                <td class="tdClass">{{'Distance' | translate | async}} ({{userUOD}})</td>
                <td > </td>
                <td *ngIf="ShowTodayWorn"></td>
              </tr>
              <tr *ngIf="distanceDifference">
                <td></td>
                <td class="tdClass">{{'Distance Difference' | translate | async}} ({{userUOD}})</td>
                <td *ngIf="ShowTodayWorn"> </td>
                <td > </td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">{{'Propel Hrs' | translate | async}}</td>
                <td ></td>
                <td *ngIf="ShowTodayWorn"></td>
              </tr>
              <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                <td></td>
                <td class="tdClass">{{'Propel %' | translate | async}}</td>
                <td ></td>
                <td *ngIf="ShowTodayWorn"></td>
              </tr>
              <tr *ngIf="jobsite">
                <td></td>
                <td class="tdClass">{{'Jobsite' | translate | async}}</td>
                <td ></td>
                <td *ngIf="ShowTodayWorn"></td>
              </tr>
              <tr *ngIf="inspector">
                <td></td>
                <td class="tdClass">Inspector</td>
                <td class="tdClass" *ngIf="ShowTodayWorn"></td>
                <td ></td>
              </tr>
              <tr>
                <td class="tdClass">{{'Left Side' | translate | async}}</td>
                <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass">{{'Components' | translate | async}}</td>
                <td *ngIf="ShowTodayWorn"></td>
                <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass">{{'Type' | translate | async}}</td>
                <td  class="tdClass"><span *ngIf="worn">{{'Worn%' | translate | async}}</span></td>

              </tr>
              <ng-container *ngFor="let info of LeftSystem">
                <tr>
                  <td></td>
                  <td *ngIf="!info.IsChild" class="tdClass SerialAndUnitText" style="padding: 19px 17px;cursor: context-menu;"
                    title=" {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}">
                    <span>
                      {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}
                    </span>
                  </td>
                  <td *ngIf="info.IsChild" class="line-cell tdClass" 
                      title=" {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}">
                      <div class="line-vert{{getChildRowPosition(info.Id,info.SystemId)}}"></div>
                      <div class="line-hor"></div>
                      <span class="line-vert-span">
                        {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}
                      </span>
                    </td>

                  <td *ngIf="ShowTodayWorn">
                    

                     <span style="padding: 3px 21px;width: 110px;"
                [ngClass]="GetEvalColour(info.CompartTypeId, info.ForeCastPercentWorn)">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{truncateToOneDecimal(info.ForeCastPercentWorn) | number:'1.1-1'}}%</div>

              </span>
                    
                    <!-- <span *ngIf="info.PercentWorn != -9999" class="Eval-{{ info.EvalCode}}"
                      style="padding: 3px 21px;width: 110px;">{{info.ForeCastPercentWorn | number:'1.1-1'}}%</span>
                    <span *ngIf="info.PercentWorn == -9999" class="Eval-{{ info.EvalCode}}"
                      style="padding: 3px 21px;width: 110px;">-</span> -->
                  </td>
                  <td >
                    <div *ngIf="!showorHideCurrentStatus">
                    <span *ngIf="info.isLatest==true" class="Eval-{{ info.EvalCode}}"
                      style="padding: 3px 21px;width: 110px;">
                      <div *ngIf="info.reading != -1">
                        {{truncateToOneDecimal(info.PercentWorn) | number:'1.1-1'}}%
                      </div>
                      <div *ngIf="info.reading == -1">
                        {{'-'}}
                      </div>
                    </span>
                    <span *ngIf="info.isLatest==false" class="Eval-{{ info.EvalCode}}"
                      style="border-style: double;border-width: thick; padding: 3px 21px;width: 110px;"
                      title="Result are not from latest inspection">
                      <div *ngIf="info.reading != -1">
                        {{truncateToOneDecimal(info.PercentWorn)| number:'1.1-1'}}%
                      </div>
                      <div *ngIf="truncateToOneDecimal(info.reading) == -1">
                        {{'-'}}
                      </div>
                    </span>
                    </div>
                     <div *ngIf="showorHideCurrentStatus">
                      <span class="Eval-{{ info.EvalCode}}"
                      style="padding: 3px 21px;width: 110px;">
                      <div *ngIf="info.reading != -1">
                        {{truncateToOneDecimal(info.PercentWornForecast) | number:'1.1-1'}}%
                      </div>
                      <div *ngIf="truncateToOneDecimal(info.reading) == -1">
                        {{'-'}}
                      </div>
                    </span>
                    
                    </div>
                  </td>
                </tr>
              </ng-container>

            </tbody>
          </table>
        </div>

        <div style="overflow-x: auto;width: 50%;">
          <table class="table table--striped table--full-width">
            <tbody>
              <div style="display: flex; flex-direction: row;">
                <ng-container *ngFor="let data of inspectionsHistory">
                  <div>
                    <tr>
                      <td class="tdClass" style="    padding: 10px;text-align: center;font-size: 16px;">
                        <i class="material-icons square-button__icon" (click)="OpenInspectionComment(data)"
                          style="cursor: pointer;" title="{{'General Notes' | translate | async}}">description</i>
                      </td>

                    </tr>
                    <tr>
                      <td class="tdClass">{{data.InspectionType}}</td>

                    </tr>
                    <tr>
                      <td class="tdClass">{{data.Date}}</td>

                    </tr>
                    <tr>

                      <td class="tdClass">{{data.Smu}}</td>
                    </tr>
                    <tr>

                      <td class="tdClass">{{data.AverageDailyUsage}}</td>
                    </tr>
                    <tr *ngIf="distance">
                      <td class="tdClass">{{convertDistanceKmToMi(data.DistanceKm)}}</td>
                    </tr>
                    <tr *ngIf="distanceDifference">
                      <td class="tdClass">{{convertDistanceKmToMi(data.DistanceKmDifference)}}</td>
                    </tr>
                    <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                      <td class="tdClass">{{data.EPMU}} </td>
                    </tr>
                    <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                      <td class="tdClass">{{data.PMUpercentage.toFixed(1)}}% </td>
                    </tr>
                    <tr *ngIf="jobsite">
                      <td class="tdClass" style="white-space: nowrap;">{{data.Jobsite}} </td>
                    </tr>
                    <tr *ngIf="inspector">
                      <td class="tdClass" style="white-space: nowrap;">{{data.Inspector}} </td>
                    </tr>
                    <tr>
                      <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass"><span *ngIf="worn">{{'Worn%' | translate | async}}</span></td>
                      <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass SerialAndUnitText">
                        {{data.InspectionType}}</td>
                    </tr>
                    <ng-container *ngFor="let info of data.LeftSide">
                      <tr>
                        <td class="tdClass">
                          <span *ngIf="data.InspectionType=='Maintenance' && info.CMU==0 && info.Worn==0" class="Eval-A"
                            style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn)}}%</span>
                          <span *ngIf="data.InspectionType=='Maintenance' && info.CMU>0 && info.Worn != 0"
                            class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn)}}%</span>
                          <span *ngIf="data.InspectionType=='Maintenance' && info.CMU==0 && info.Worn != 0"
                            class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn)}}%</span>
                          <span
                            *ngIf="data.InspectionType=='Maintenance' && info.Worn==0 && info.reading==-1 && info.CMU!=0"
                            class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">N/A</span>
                          <span
                            *ngIf="data.InspectionType=='Maintenance' && info.Worn==0 && info.reading==0 &&  info.CMU>0 "
                            class="Eval-A" style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn)}}%</span>
                          <span *ngIf="data.InspectionType!='Maintenance' && info.reading!=-1" class="Eval-{{ info.Eval}}" 
                            style="padding: 3px 21px;width: 110px;">{{ truncateToOneDecimal(info.Worn) | number:'1.1-1'}}%</span>
                            <span
                            *ngIf="data.InspectionType!='Maintenance' && info.reading==-1"
                            class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">-</span>
                        </td>
                      </tr>

                    </ng-container>

                  </div>



                </ng-container>
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </div>



    <div class="panel panel--components">
      <div class="panel__header" style="flex-flow: row-reverse">

      </div>

      <div class="panel__content no-padding">
        <div style="display: flex;flex-direction: row;" *ngIf="RightSystem!=null">
          <div style="width:50%">
            <table class="table table--striped table--full-width">
              <tbody>
                <tr>
                  <td></td>
                  <td class="tdClass">{{'Inspection Type' | translate | async}}</td>
                  <td class="tdClass" *ngIf="ShowTodayWorn">{{'% Worn Today' | translate | async}}</td>
                  <td class="tdClass">{{'Last Insp. % Worn' | translate | async}}</td>

                </tr>
                <tr>
                  <td class="tdClass"> {{eqName}}</td>
                  <td class="tdClass">{{'DATE' | translate | async}}</td>
                  <td class="tdClass" *ngIf="ShowTodayWorn">{{ToadysDate | date:'dd-MMM-yyyy'}}</td>
                  <td ></td>
                </tr>
                <tr>
                  <td></td>
                  <td class="tdClass">SMU</td>
                  <td *ngIf="ShowTodayWorn">{{ForeacastCmu}}</td>
                  <td ></td>
                </tr>
                <tr *ngIf="distance">
                  <td></td>
                  <td class="tdClass">{{'Distance' | translate | async}} (Km)</td>
                  <td *ngIf="ShowTodayWorn"></td>
                  <td > </td>
                </tr>
                <tr *ngIf="distanceDifference">
                  <td></td>
                  <td class="tdClass">{{'Distance Difference' | translate | async}} (Km)</td>
                  <td *ngIf="ShowTodayWorn"> </td>
                  <td > </td>
                </tr>
                <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                  <td></td>
                  <td class="tdClass">{{'Propel Hrs' | translate | async}}</td>
                  <td ></td>
                </tr>
                <tr *ngIf="(FamilyId==177 || FamilyId==203)">
                  <td></td>
                  <td class="tdClass">{{'Propel %' | translate | async}}</td>
                  <td > </td>
                </tr>
                <tr *ngIf="jobsite">
                  <td></td>
                  <td class="tdClass">{{'Jobsite' | translate | async}}</td>
                  <td ></td>
                  <td *ngIf="ShowTodayWorn"></td>
                </tr>
                <tr *ngIf="inspector">
                  <td></td>
                  <td class="tdClass">{{'Inspector' | translate | async}}</td>
                  <td class="tdClass" *ngIf="ShowTodayWorn"></td>
                  <td ></td>
                </tr>
                <tr>
                  <td class="tdClass">{{'Right Side' | translate | async}}</td>
                  <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass">{{'Components' | translate | async}}</td>
                  <td *ngIf="ShowTodayWorn"></td>
                  <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass ">{{'Type' | translate | async}}</td>
                  <td  class="tdClass"><span *ngIf="worn">{{'Worn%' | translate | async}}</span></td>

                </tr>
                <ng-container *ngFor="let info of RightSystem">
                  <tr>
                    <td></td>
                    <td  *ngIf="!info.IsChild" class="tdClass SerialAndUnitText" style="padding: 19px 17px;cursor: context-menu;"
                      title=" {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}">
                      <span >
                        {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}
                      </span>
                    </td>
                     <td *ngIf="info.IsChild" class="tdClass line-cell" 
                      title=" {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}">
                      <div class=" line-vert{{getChildRowPosition(info.Id,info.SystemId)}}"></div>
                      <div class="line-hor"></div>
                      <span class="line-vert-span">
                        {{info.Name}} {{showPosition(info.Position, info.CompartTypeId)}}
                      </span>
                    </td>

                    <td *ngIf="ShowTodayWorn">
                      
                       <span style="padding: 3px 21px;width: 110px;"
                  [ngClass]="GetEvalColour(info.CompartTypeId, info.ForeCastPercentWorn)">
                <div style="text-align: -webkit-center !important ; display: inline-block;">
                  {{truncateToOneDecimal(info.ForeCastPercentWorn) | number:'1.1-1'}}%</div></span>
                      
                      <!-- <span *ngIf="info.PercentWorn != -9999" class="Eval-{{ info.EvalCode}}"
                        style="padding: 3px 21px;width: 110px;">{{info.ForeCastPercentWorn | number:'1.1-1'}}%</span>
                      <span *ngIf="info.PercentWorn == -9999" class="Eval-{{ info.EvalCode}}"
                        style="padding: 3px 21px;width: 110px;">-</span> -->
                    </td>
                    <td >

                      <!-- <span *ngIf="info.PercentWorn != -9999" class="Eval-{{ info.EvalCode}}" style="padding: 3px 21px;width: 110px;">{{info.PercentWorn}}%</span>
                
                <span *ngIf="info.PercentWorn == -9999" class="Eval-{{ info.EvalCode}}" style="padding: 3px 21px;width: 110px;">-</span> -->

                      <div *ngIf="!showorHideCurrentStatus">
                      <span *ngIf="info.isLatest==true" class="Eval-{{ info.EvalCode}}"
                        style="padding: 3px 21px;width: 110px;">
                        <div *ngIf="info.reading != -1">
                          {{truncateToOneDecimal(info.PercentWorn)| number:'1.1-1'}}%
                        </div>
                        <div *ngIf="info.reading == -1">
                          {{'-'}}
                        </div>
                      </span>
                      <span *ngIf="info.isLatest==false" class="Eval-{{ info.EvalCode}}"
                        style="border-style: double;border-width: thick; padding: 3px 21px; width: 110px;"
                        title="Result are not from latest inspection">
                        <div *ngIf="info.reading != -1">
                          {{truncateToOneDecimal(info.PercentWorn)| number:'1.1-1'}}%
                        </div>
                        <div *ngIf="info.reading == -1">
                          {{'-'}}
                        </div>
                      </span>
                      </div>
                    <div *ngIf="showorHideCurrentStatus">
                      <span class="Eval-{{ info.EvalCode}}"
                        style="padding: 3px 21px;width: 110px;">
                        <div *ngIf="info.reading != -1">
                          {{truncateToOneDecimal(info.PercentWornForecast) | number:'1.1-1'}}%
                        </div>
                        <div *ngIf="info.reading == -1">
                          {{'-'}}
                        </div>
                      </span>
                      
                      </div>

                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div style="overflow-x: auto;width: 50%;">
            <table class="table table--striped table--full-width">
              <tbody>
                <div style="display: flex; flex-direction: row;">
                  <ng-container *ngFor="let data of inspectionsHistory">
                    <div>
                      <tr>
                        <td class="tdClass">{{data.InspectionType}}</td>

                      </tr>
                      <tr>
                        <td class="tdClass">{{data.Date}}</td>

                      </tr>
                      <tr>

                        <td class="tdClass">{{data.Smu}}</td>
                      </tr>
                      <tr *ngIf="distance">
                        <td class="tdClass">{{data.DistanceKm}}</td>
                      </tr>
                      <tr *ngIf="distanceDifference">
                        <td class="tdClass">{{data.DistanceKmDifference}}</td>
                      </tr>
                      <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                        <td class="tdClass">{{data.EPMU}} </td>
                      </tr>
                      <tr *ngIf="(FamilyId==177 || FamilyId==203)">

                        <td class="tdClass">{{data.PMUpercentage.toFixed(1)}}% </td>
                      </tr>
                      <tr *ngIf="jobsite">
                        <td class="tdClass" style="white-space: nowrap;">{{data.Jobsite}} </td>
                      </tr>
                      <tr *ngIf="inspector">
                        <td class="tdClass" style="white-space: nowrap;">{{data.Inspector}} </td>
                      </tr>
                      <tr>
                        <td *ngIf="(FamilyId!=177 && FamilyId!=203)" class="tdClass"><span *ngIf="worn">{{'Worn%' | translate | async}}</span>
                        </td>
                        <td *ngIf="(FamilyId==177 || FamilyId==203)" class="tdClass SerialAndUnitText">
                          {{data.InspectionType}}</td>
                      </tr>
                      <ng-container *ngFor="let info of data.RightSide">
                        <tr>
                          <td class="tdClass">
                            <!-- <span class="Eval-{{ info.Eval}}" style="padding: 3px 21px; width: 110px;">{{info.Worn}} %</span> -->
                            <span *ngIf="data.InspectionType=='Maintenance' && info.CMU==0 && info.Worn==0"
                              class="Eval-A" style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn) }}%</span>
                            <span *ngIf="data.InspectionType=='Maintenance' && info.CMU>0 && info.Worn != 0"
                              class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn)}}%</span>
                            <span *ngIf="data.InspectionType=='Maintenance' && info.CMU==0 && info.Worn != 0"
                              class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn)}}%</span>
                            <span
                              *ngIf="data.InspectionType=='Maintenance' && info.Worn==0 && info.reading==-1 && info.CMU!=0"
                              class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">N/A</span>
                            <span
                              *ngIf="data.InspectionType=='Maintenance' && info.Worn==0 && info.reading==0 &&  info.CMU>0 "
                              class="Eval-A" style="padding: 3px 21px;width: 110px;">{{info.Worn}}%</span>
                            <span *ngIf="data.InspectionType!='Maintenance' && info.reading!=-1" class="Eval-{{ info.Eval}}"
                              style="padding: 3px 21px;width: 110px;">{{truncateToOneDecimal(info.Worn) | number:'1.1-1'}}%</span>
                              <span
                              *ngIf="data.InspectionType!='Maintenance' && info.reading==-1"
                              class="Eval-{{ info.Eval}}" style="padding: 3px 21px;width: 110px;">-</span>
                          </td>
                        </tr>
                      </ng-container>

                    </div>



                  </ng-container>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!--Thermography Inspection-->


  <div *ngIf="thermographyInspection==true">
    <div class="panel__content no-padding">
      <div class="center" *ngIf="ThermoSystem_L==null && ThermoSystem_R==null">
        <mat-spinner></mat-spinner>
      </div>

      <div style="display: flex;flex-direction: row;" *ngIf="ThermoSystem_L!=null">
        <div style="width:40%">
          <table class="table table--striped table--full-width">
            <tbody>
              <tr>
                <td class="tdClass"> {{eqName}}</td>
                <td class="tdClass">{{'DATE' | translate | async}}</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass">{{'SMU' | translate | async}}</td>
              </tr>
              <tr>
                <td class="tdClass">{{'Left Side' | translate | async}}</td>
                <td class="tdClass">{{'Components' | translate | async}}</td>
              </tr>
              <tr>
                <td></td>
                <td class="tdClass" style="padding: 15px 17px;cursor: pointer;" (click)="ChainExpandL()">
                  <span class="material-icons" style="vertical-align: middle;">{{'Reorder' | translate | async}} </span> Link - ( Worst )
                </td>
              </tr>

              <ng-container *ngIf="IsLeftExapand">
                <ng-container *ngFor="let info of Chaindata">
                  <tr>
                    <td></td>
                    <td class="tdClass" style="padding: 19px 17px;">
                      <span *ngIf="info.Position==1"> Link - {{info.Position}} {{'Forward' | translate | async}}</span>
                      <span *ngIf="info.Position!=1"> Link - {{info.Position}}</span>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>

              <ng-container *ngFor="let info of ThermoSystem_L">
                <tr>
                  <td></td>
                  <td class="tdClass" style="padding: 19px 17px;">
                    <span>
                      {{info.ComponentName}} {{showPosition(info.Position, info.CompartTypeId)}}
                    </span>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </div>

        <div style="overflow-x: auto;">
          <table class="table table--striped table--full-width">
            <tbody>
              <div style="display: flex; flex-direction: row;">
                <ng-container *ngFor="let data of inspectionsHistoryThermo">
                  <div>
                    <tr>
                      <td class="tdClass">{{data.Date}}</td>
                    </tr>
                    <tr>
                      <td class="tdClass">{{data.Smu}}</td>
                    </tr>

                    <tr>
                      <td class="tdClass">{{'Severity' | translate | async}}</td>
                    </tr>
                    <tr>
                      <td class="tdClass">
                        <span class="eval-{{data.ChainWorst_L}}"
                          style="padding: 3px 21px; width: 110px;">{{data.ChainWorst_L}}</span>
                      </td>
                    </tr>

                    <ng-container *ngIf="data.L_expanded">
                      <tr *ngFor="let info of data.LeftThermoChain">
                        <td class="tdClass">
                          <span class="eval-{{info.Eval}}"
                            style="padding: 3px 21px; width: 110px;">{{info.ThemEval}}</span>
                        </td>
                      </tr>
                    </ng-container>

                    <ng-container *ngFor="let info of data.LeftSide">
                      <tr>
                        <td class="tdClass">
                          <span class="eval-{{info.Eval}}"
                            style="padding: 3px 21px;width: 110px;">{{info.ThemEval}}</span>
                        </td>
                      </tr>
                    </ng-container>
                  </div>



                </ng-container>
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </div>



    <div class="panel panel--components">
      <div class="panel__header" style="flex-flow: row-reverse">

      </div>

      <div class="panel__content no-padding">
        <div style="display: flex;flex-direction: row;" *ngIf="ThermoSystem_R!=null">
          <div style="width:40%">
            <table class="table table--striped table--full-width">
              <tbody>
                <tr>
                  <td class="tdClass"> {{eqName}}</td>
                  <td class="tdClass">{{'DATE' | translate | async}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="tdClass">{{'SMU' | translate | async}}</td>
                </tr>
                <tr>
                  <td class="tdClass">{{'Right Side' | translate | async}}</td>
                  <td class="tdClass">{{'Components' | translate | async}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="tdClass" style="padding: 15px 17px;cursor: pointer;" (click)="ChainExpandR()">
                    <span class="material-icons" style="vertical-align: middle;">{{'Reorder' | translate | async}} </span> Link - ( Worst )
                  </td>
                </tr>

                <ng-container *ngIf="IsRightExapand">
                  <ng-container *ngFor="let info of Chaindata">
                    <tr>
                      <td></td>
                      <td class="tdClass" style="padding: 19px 17px;">
                        <span *ngIf="info.Position==1"> Link - {{info.Position}} {{'Forward' | translate | async}}</span>
                        <span *ngIf="info.Position!=1"> Link - {{info.Position}}</span>
                      </td>
                    </tr>
                  </ng-container>
                </ng-container>
                <ng-container *ngFor="let info of ThermoSystem_R">
                  <tr>
                    <td></td>
                    <td class="tdClass SerialAndUnitText" style="padding: 19px 17px;">
                      <span>
                        {{info.ComponentName}} {{showPosition(info.Position, info.CompartTypeId)}}
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div style="overflow-x: auto;">
            <table class="table table--striped table--full-width">
              <tbody>
                <div style="display: flex; flex-direction: row;">
                  <ng-container *ngFor="let data of inspectionsHistoryThermo">
                    <div>
                      <tr>
                        <td class="tdClass">{{data.Date}}</td>

                      </tr>
                      <tr>

                        <td class="tdClass">{{data.Smu}}</td>
                      </tr>

                      <tr>
                        <td class="tdClass">{{'Severity' | translate | async}}</td>
                      </tr>
                      <tr>
                        <td class="tdClass">
                          <span class="eval-{{data.ChainWorst_R}}"
                            style="padding: 3px 21px; width: 110px;">{{data.ChainWorst_R}}</span>
                        </td>
                      </tr>
                      <ng-container *ngIf="data.R_expanded">
                        <tr *ngFor="let info of data.RightThermoChain">
                          <td class="tdClass">
                            <span class="eval-{{info.Eval}}"
                              style="padding: 3px 21px; width: 110px;">{{info.ThemEval}}</span>
                          </td>
                        </tr>
                      </ng-container>
                      <ng-container *ngFor="let info of data.RightSide">
                        <tr>
                          <td class="tdClass">
                            <span class="eval-{{info.Eval}}"
                              style="padding: 3px 21px;width: 110px;">{{info.ThemEval}}</span>
                          </td>
                        </tr>
                      </ng-container>
                    </div>



                  </ng-container>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>



    <div class="panel panel--components">
      <div class="panel__header">
        <b>Left Side Additional Components</b>
      </div>

      <div class="panel__content no-padding">
        <div style="display: flex;flex-direction: row;" *ngIf="ThermoSystem_Addi_L!=null">
          <div style="width:40%">
            <table class="table table--striped table--full-width">
              <tbody>
                <tr>
                  <td class="tdClass"> {{eqName}}</td>
                  <td class="tdClass">{{'DATE' | translate | async}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="tdClass">{{'SMU' | translate | async}}</td>
                </tr>
                <tr>
                  <td class="tdClass">{{'Left Side' | translate | async}}</td>
                  <td class="tdClass">Components</td>
                </tr>
                <ng-container *ngFor="let info of ThermoSystem_Addi_L">
                  <tr>
                    <td></td>
                    <td class="tdClass" style="padding: 19px 17px;">
                      <span>
                        {{info.ComponentName}}
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div style="overflow-x: auto;">
            <table class="table table--striped table--full-width">
              <tbody>
                <div style="display: flex; flex-direction: row;">
                  <ng-container *ngFor="let data of inspectionsHistoryThermo">
                    <div>
                      <tr>
                        <td class="tdClass">{{data.Date}}</td>

                      </tr>
                      <tr>

                        <td class="tdClass">{{data.Smu}}</td>
                      </tr>

                      <tr>
                        <td class="tdClass">Severity</td>
                      </tr>
                      <ng-container *ngFor="let info of data.LeftAdditional">
                        <tr>
                          <td class="tdClass">
                            <span class="eval-{{info.Eval}}"
                              style="padding: 3px 21px;width: 110px;">{{info.ThemEval}}</span>
                          </td>
                        </tr>
                      </ng-container>
                    </div>



                  </ng-container>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel--components">
      <div class="panel__header">
        <b>{{'Right Side Additional Components' | translate | async}}</b>
      </div>

      <div class="panel__content no-padding">
        <div style="display: flex;flex-direction: row;" *ngIf="ThermoSystem_Addi_R!=null">
          <div style="width:40%">
            <table class="table table--striped table--full-width">
              <tbody>
                <tr>
                  <td class="tdClass"> {{eqName}}</td>
                  <td class="tdClass">{{'DATE' | translate | async}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="tdClass">{{'SMU' | translate | async}}</td>
                </tr>
                <tr>
                  <td class="tdClass">{{'Right Side' | translate | async}}</td>
                  <td class="tdClass">{{'Components' | translate | async}}</td>
                </tr>
                <ng-container *ngFor="let info of ThermoSystem_Addi_R">
                  <tr>
                    <td></td>
                    <td class="tdClass" style="padding: 19px 17px;">
                      <span>
                        {{info.ComponentName}}
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div style="overflow-x: auto;">
            <table class="table table--striped table--full-width">
              <tbody>
                <div style="display: flex; flex-direction: row;">
                  <ng-container *ngFor="let data of inspectionsHistoryThermo">
                    <div>
                      <tr>
                        <td class="tdClass">{{data.Date}}</td>

                      </tr>
                      <tr>

                        <td class="tdClass">{{data.Smu}}</td>
                      </tr>

                      <tr>
                        <td class="tdClass">{{'Severity' | translate | async}}</td>
                      </tr>
                      <ng-container *ngFor="let info of data.RightAdditional">
                        <tr>
                          <td class="tdClass">
                            <span class="eval-{{info.Eval}}"
                              style="padding: 3px 21px;width: 110px;">{{info.ThemEval}}</span>
                          </td>
                        </tr>
                      </ng-container>
                    </div>



                  </ng-container>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="panel panel--components">
      <div class="panel__header">
        <b>{{'No Side Additional Components' | translate | async}}</b>
      </div>

      <div class="panel__content no-padding">
        <div style="display: flex;flex-direction: row;" *ngIf="ThermoSystem_Addi_No!=null">
          <div style="width:40%">
            <table class="table table--striped table--full-width">
              <tbody>
                <tr>
                  <td class="tdClass"> {{eqName}}</td>
                  <td class="tdClass">{{'DATE' | translate | async}}</td>
                </tr>
                <tr>
                  <td></td>
                  <td class="tdClass">{{'SMU' | translate | async}}</td>
                </tr>
                <tr>
                  <td class="tdClass">{{'No Side' | translate | async}}</td>
                  <td class="tdClass">{{'Components' | translate | async}}</td>
                </tr>
                <ng-container *ngFor="let info of ThermoSystem_Addi_No">
                  <tr>
                    <td></td>
                    <td class="tdClass" style="padding: 19px 17px;">
                      <span>
                        {{info.ComponentName}}
                      </span>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>

          <div style="overflow-x: auto;">
            <table class="table table--striped table--full-width">
              <tbody>
                <div style="display: flex; flex-direction: row;">
                  <ng-container *ngFor="let data of inspectionsHistoryThermo">
                    <div>
                      <tr>
                        <td class="tdClass">{{data.Date}}</td>

                      </tr>
                      <tr>

                        <td class="tdClass">{{data.Smu}}</td>
                      </tr>

                      <tr>
                        <td class="tdClass">{{'Severity' | translate | async}}</td>
                      </tr>
                      <ng-container *ngFor="let info of data.NoAdditional">
                        <tr>
                          <td class="tdClass">
                            <span class="eval-{{info.Eval}}"
                              style="padding: 3px 21px;width: 110px;">{{info.ThemEval}}</span>
                          </td>
                        </tr>
                      </ng-container>
                    </div>



                  </ng-container>
                </div>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--End Thermo Inspection-->
